





























































































import {Component, Prop, Model} from 'vue-property-decorator';
import CommonVue from '../models/commonVue';
import {BusEvent} from '@/models/bus';

import TranscriptArpabet from '../api/transcriptArpabet';

import Modal from '@/components/Modal.vue';
import EditIcon from '../components/icons/EditIcon.vue';
import transcriptArpabet from "../api/transcriptArpabet";
import speakingContent from "@/api/speakingContent";
import ExtraInfo from "../api/extraInfo";
import FieldTextRange from "@/components/FieldTextRange.vue";
import {ExtraInfoFields} from "@/api/common";
import DropDownText from "@/components/DropDownText.vue";

@Component({
    components: {
        'field-text-range': FieldTextRange,
        'modal': Modal,
        'edit-icon': EditIcon,
        'drop-down-text': DropDownText,
    },
})
export default class FieldExtraInfo extends CommonVue {
    @Model('update') public extra_info_list!: ExtraInfo[];
    @Prop({type: String,}) public sentence!: string;
    @Prop({type: Boolean, default: false}) public disabled?: boolean;

    public dropOptions = ExtraInfoFields.OPTIONS;
    public dropPresentation = ExtraInfoFields.OPTIONS;

    public info: ExtraInfo = null;
    public isNewInfo: boolean = false;
    public showModal: boolean = false;

    public edit(info: ExtraInfo) {
        this.info = info;
        this.isNewInfo = false;
        this.showModal = true;
    }

    public newInfo() {
        this.info = new ExtraInfo();
        this.isNewInfo = true;
        this.showModal = true;
    }

    public saveClicked() {
        if (!this.info) {
            return;
        }

        this.busy = true;

        try {
            this.checkMandatoryFields();
            if (this.isNewInfo) {
                this.extra_info_list.push(this.info);
            }

            this.busy = false;
            this.showModal = false;
        } catch (e) {
            this.busy = false;
            this.$bus.$emit(BusEvent.ERROR, 'Could not save info', e);
        }
    }

    public checkMandatoryFields() {
        // Check if text is filled
        if(!this.info.type || !this.info.start_index || !this.info.end_index) {
            throw Error('Please insert all fields.');
        }

    }

    public deleteClicked() {
        const newList = this.extra_info_list.filter((value) => {
            return value !== this.info;
        });

        this.$emit('update', newList);
        this.showModal = false;
    }
}

